// extracted by mini-css-extract-plugin
export default {"headerTitle":"PageTitle_headerTitle__KtAiQ","headerTitleContainer":"PageTitle_headerTitleContainer__y4u5C","headerSubTitleContainer":"PageTitle_headerSubTitleContainer__Zb34J"};